import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

@Feature()
export class TextFormatFeature extends BaseTitleBarFeature {
    constructor() {
        super();
    }

    public handleClick() {
        this.getMenuManager()?.actionTextFormat();
    }
}
